import { animate as motionAnimate, timeline as motionTimeline } from "//as.sciconsports.com/cdn/shop/t/12/assets/vendor.min.js?v=52426788336887041471791965688";
import { DialogElement, SectionHeader, Drawer, FacetApplyButton } from "//as.sciconsports.com/cdn/shop/t/12/assets/theme.js?v=125998970846436972391791965837";

var reduceDrawerAnimation = window.matchMedia("(prefers-reduced-motion: reduce)").matches || window.themeVariables.settings.reduceDrawerAnimation;

var MobileNavigationDrawer = class extends DialogElement {
    static get observedAttributes() {
        return ["id", "open"];
    }

    constructor() {
        super();

        const template2 = document.getElementById(this.template).content.cloneNode(true);
        this.attachShadow({ mode: "open" }).appendChild(template2);
        this.shadowRoot.addEventListener("slotchange", (event) => this._updateSlotVisibility(event.target));
        this.openMenuMsg = null;
        this.closeMenuMsg = null;
    }

    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("aria-modal", "true");
        this.shadowRoot.querySelector('[part="overlay"]')?.addEventListener("click", this.hide.bind(this), { signal: this._abortController.signal });
        Array.from(this.shadowRoot.querySelectorAll("slot")).forEach((slot) => this._updateSlotVisibility(slot));

        this.toggleMenuBtn = document.getElementById('toggle-menu-button');

        if (this.toggleMenuBtn) {
            this.openMenuMsg = this.toggleMenuBtn.getAttribute('data-open-msg');
            this.closeMenuMsg = this.toggleMenuBtn.getAttribute('data-close-msg');

            this.toggleMenuBtn.addEventListener("click", () => {
                if (this.open) {
                    this.hide.bind(this);
                } else {
                    this.show.bind(this);
                }
            }, { signal: this._abortController.signal });
        }
    }

    get template() {
        return this.getAttribute("template") || "drawer-default-template";
    }

    get shouldLock() {
        return true;
    }
    get shouldAppendToBody() {
        return true;
    }

    get openFrom() {
        return window.matchMedia(`${window.themeVariables.breakpoints["sm-max"]}`).matches ? "bottom" : this.getAttribute("open-from") || "right";
    }

    _getClipPathProperties() {
        switch (this.openFrom) {
            case "left":
                return document.dir === "ltr" ? ["inset(0 100% 0 0 round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"] : ["inset(0 0 0 100% round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
            case "right":
                return document.dir === "ltr" ? ["inset(0 0 0 100% round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm)"] : ["inset(0 100% 0 0 round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
            case "bottom":
                return ["inset(100% 0 0 0 round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
            case "top":
                return ["inset(0 0 100% 0 round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
        }
    }

    _setInitialPosition() {
        const sizes = this.getHTMLComputedStyle();
        this.style.left = "-100%";
        this.style.right = "auto";
        this.style.bottom = "0px";
        this.style.top = sizes.headerHeight + "px";
        const overlay = this.shadowRoot.querySelector('[part="overlay"]');
        overlay.style.right = "-100%";
    }

    _showTransition(animate11 = true) {
        let animationControls;
        this._setInitialPosition();

        if (reduceDrawerAnimation) {
            animationControls = motionAnimate(this, { opacity: [0, 1], left: ["-100%", "0"] }, { duration: 0.2 });
        } else {
            const content = this.shadowRoot.querySelector('[part="content"]');
            const overlay = this.shadowRoot.querySelector('[part="overlay"]');

            animationControls = motionTimeline([
                [this, { opacity: [0, 1], left: ["-100%", "0"] }, { duration: 0.5 }],
                [overlay, { opacity: [0, 1], right: ["-100%", "0"] }, { duration: 0.5 }],
                [content, { clipPath: this._getClipPathProperties() }, { duration: 0.5, easing: [0.86, 0, 0.07, 1] }]
            ]);
        }

        animate11 ? animationControls.play() : animationControls.finish();

        return animationControls.finished.then(() => this.classList.add("show-close-cursor"));
    }

    _hideTransition() {
        let animationControls;

        if (reduceDrawerAnimation) {
            animationControls = motionAnimate(this, { opacity: [1, 0], left: ["0", "-100%"] }, { duration: 0.2 });
        } else {
            const content = this.shadowRoot.querySelector('[part="content"]');
            const overlay = this.shadowRoot.querySelector('[part="overlay"]');

            animationControls = motionTimeline([
                [this, { opacity: [null, 0], left: ["0", "-100%"] }, { duration: 0.5 }],
                [overlay, { opacity: [0, 1], right: ["0", "-100%"] }, { duration: 0.5 }],
                [content, { clipPath: this._getClipPathProperties().reverse() }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
            ]);
        }

        return animationControls.finished.then(() => this.classList.remove("show-close-cursor"));
    }

    _updateSlotVisibility(slot) {
        if (!["header", "footer", "body"].includes(slot.name)) {
            return;
        }

        slot.parentElement.hidden = slot.assignedElements({ flatten: true }).length === 0;
    }

    show() {
        const blackStickyHeight = this.getHTMLComputedStyle().blackStickyHeight;
        let bodyTopPosition = document.body.getBoundingClientRect().top;

        if (bodyTopPosition < 0) {
            bodyTopPosition = bodyTopPosition * -1;
        }

        if (blackStickyHeight && bodyTopPosition < blackStickyHeight) {
            window.scrollTo({
                top: blackStickyHeight,
                behavior: "smooth"
            });
        }

        document.documentElement.classList.add('menu-is-open');
        this.setSrOnly('close');
        super.show();
    }

    hide() {
        document.documentElement.classList.remove('menu-is-open');
        this.setSrOnly('open');
        super.hide();
    }

    setSrOnly(menuState = 'close') {
        if (!this.toggleMenuBtn) return;
        const srOnlyElement = this.toggleMenuBtn.querySelector('.sr-only');

        if (menuState === 'close') {
            srOnlyElement.textContent = this.closeMenuMsg;
        }

        if (menuState === 'open') {
            srOnlyElement.textContent = this.openMenuMsg;
        }
    }

    getHTMLComputedStyle() {
        const computedStyle = getComputedStyle(document.documentElement);
        const blackStickyHeight = computedStyle.getPropertyValue('--announcement-bar-height');
        const headerHeight = computedStyle.getPropertyValue('--header-height');

        return {
            blackStickyHeight: parseInt(blackStickyHeight),
            headerHeight: parseInt(headerHeight)
        }
    }
};
if (!window.customElements.get("custom-x-drawer")) {
    window.customElements.define("custom-x-drawer", MobileNavigationDrawer);
}


var CustomDrawer = class extends Drawer {
    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    get openFrom() {
        return this.getAttribute("open-from") || "right";
    }
};
if (!window.customElements.get("custom-drawer")) {
    window.customElements.define("custom-drawer", CustomDrawer);
}


var CustomFacetDrawer = class extends CustomDrawer {
    constructor() {
        super();
        this.addEventListener("dialog:after-hide", this._submitForm);
    }

    _submitForm() {
        const form = this.querySelector("#facet-form");

        if (HTMLFormElement.prototype.requestSubmit) {
            form.requestSubmit();
        } else {
            form.dispatchEvent(new Event("submit", { cancelable: true }));
        }
    }
};
if (!window.customElements.get("custom-facet-drawer")) {
    window.customElements.define("custom-facet-drawer", CustomFacetDrawer);
}


var DrawerFacetLink = class extends HTMLAnchorElement {
    constructor() {
        super();
        this.addEventListener("click", this._onFacetUpdate);
    }

    _onFacetUpdate(event) {
        event.preventDefault();
        const param = this.getAttribute('data-param');
        const value = this.getAttribute('data-value');

        const form = this.closest('#facet-form');
        const checkbox = form.querySelectorAll('input[type="checkbox"]:checked');
        let selected = [];

        if (checkbox) {
            if (param && value) {
                selected = Array.from(checkbox).filter(item => item.value === value && item.name === param);
            } else {
                selected = Array.from(checkbox);
            }

            if (selected.length) {
                for (let index = 0; index < selected.length; index++) {
                    selected[index].closest('label').click();
                }

                if (this.classList.contains('facet-clear-all')) {
                    this.closest('.active-facets').classList.add('hidden');
                } else {
                    this.closest('.removable-facet').classList.add('hidden');
                }
            }
        }
    }
};
if (!window.customElements.get("drawer-facet-link")) {
    window.customElements.define("drawer-facet-link", DrawerFacetLink, { extends: "a" });
}


var CustomFacetApplyButton = class extends FacetApplyButton {
    constructor() {
        super();

        this.addEventListener("click", this._closeDrawer);
        this.form.addEventListener("change", super._updateCount.bind(this));
        this.filterCountElement = document.createElement("span");
        this.appendChild(this.filterCountElement);
    }

    connectedCallback() {
        super.connectedCallback();
    }

    updateCountLabel() {
        const form = new FormData(this.form);
        const formEntries = Array.from(form.entries()).filter(key => key[0] !== 'sort_by' && key[0] !== 'page');

        this.filterCountElement.innerText = ` (${formEntries.length})`;
    }

    async _closeDrawer() {
        this.closest("custom-facet-drawer").hide();
    }
};
if (!window.customElements.get("custom-facet-apply-button")) {
    window.customElements.define("custom-facet-apply-button", CustomFacetApplyButton, { extends: "button" });
}


var CustomSectionHeader = class extends SectionHeader {
    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();

        const resizeObserver = new ResizeObserver((entries) => {
            if (window.innerWidth < 700) return;
            
            const entry = entries[0];
            if (entry && entry.contentRect) {
                const elementRect = entry.contentRect;
                document.documentElement.style.setProperty('--hp-section-width', parseInt(elementRect.width) + 'px');
                document.documentElement.style.setProperty('--hp-section-height', parseInt(elementRect.height) + 'px'); 
            }
        });

        resizeObserver.observe(this);
    }
};
if (!window.customElements.get("custom-section-header")) {
    window.customElements.define("custom-section-header", CustomSectionHeader);
}


var ProductCustomizer = class extends Drawer {
    constructor() {
        super();
        this.textInput = this.querySelector('#customizer__text-option');
        this.flagSelect = this.querySelector('#customizer__flag-option');
        this.selectedOptionsContainer = this.querySelector('#selected-customizer-options');
        this.selectedFlagContainer = this.selectedOptionsContainer.firstElementChild;
        this.entredTextContainer = this.selectedOptionsContainer.lastElementChild;
        this.saveButton = this.querySelector('#customizer__btn-save');
        this.cancelButton = this.querySelector('#customizer__btn-cancel');
        this.customizerResultContainer = document.getElementById('product-customizer__result');
        this.customizerButton = document.querySelector('[aria-controls="product-customizer"]');
        this.remainingCharsContainer = this.textInput.nextElementSibling.firstElementChild;
        this.originUrl = window.location.origin;
        
        this.inputChangedHandler = this.setEntredText.bind(this);
        this.selectChangedHandler = this.setSelectedFlag.bind(this);
        this.saveOptionsHandler = this.saveOptions.bind(this);
        this.cancelOptionsHandler = this.cancelData.bind(this);

        this.setCountriesSelect();
        this.createHiddenInputs();
    }

    connectedCallback() {
        super.connectedCallback();

        this.textInput.addEventListener('input', this.inputChangedHandler);
        this.flagSelect.addEventListener('change', this.selectChangedHandler);
        this.saveButton.addEventListener('click', this.saveOptionsHandler);
        this.cancelButton.addEventListener('click', this.cancelOptionsHandler);
    }

    _showTransition(animate11 = true) {
        let animationControls;
        this._setInitialPosition();

        animationControls = motionAnimate(this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.2 });
        animate11 ? animationControls.play() : animationControls.finish();
        return animationControls.finished.then(() => this.classList.add("show-close-cursor"));
    }

    _hideTransition() {
        let animationControls;
        animationControls = motionAnimate(this, { opacity: [1, 0], visibility: ["visibility", "hidden"] }, { duration: 0.2 });
        return animationControls.finished.then(() => this.classList.remove("show-close-cursor"));
    }

    _setInitialPosition() {
        const rect = this.getBoundingClientRect();
        const topPosition = rect.height / 2;
        const leftPosition = rect.width / 2;
        this.style.left = `calc(50% - ${leftPosition}px)`;
        this.style.top = `calc(50% - ${topPosition}px)`;
    }

    setEntredText() {
        this.textInput.classList.remove('error');
        this.entredTextContainer.textContent = this.textInput.value || '';
        const remainingChars = 20 - this.textInput.value.length;
        this.remainingCharsContainer.textContent = `(${remainingChars} ${this.remainingCharsContainer.getAttribute('data-label')})`;
    }

    setSelectedFlag() {
        if (this.flagSelect.value.length > 0) {
            this.flagSelect.classList.remove('error');

            const flagElement = document.createElement('img');
            flagElement.src = `${this.originUrl}/cdn/shop/files/${this.flagSelect.value}.png`;
            flagElement.alt = this.flagSelect.options[this.flagSelect.selectedIndex].text;
            this.selectedFlagContainer.innerHTML = '';
            this.selectedFlagContainer.appendChild(flagElement);
        }
    }

    setHiddenInputValue(text, flag) {
        const customizerText = document.querySelectorAll('[name="properties[text]"');
        const customizerFlag = document.querySelectorAll('[name="properties[flag]"');

        for (let index = 0; index < customizerText.length; index++) {
            customizerText[index].value = text;
        }

        for (let index = 0; index < customizerFlag.length; index++) {
            customizerFlag[index].value = flag;
        }
    }

    async setCountriesSelect() {
        const responseContent = new DOMParser().parseFromString(await (await fetch(`${window.Shopify.routes.root}?section_id=product-customizer-countries-json`)).text(), "text/html");
        const countries = JSON.parse(responseContent.querySelector('script').textContent);

        if (countries) {
            const countriesTotal = countries.length;

            for (let index = 0; index < countriesTotal; index++) {
                const countryName = countries[index].country_name;
                const option = document.createElement('option');
                option.value = countryName.replaceAll(' ', '_');
                option.textContent = countryName;
                this.flagSelect.appendChild(option);
            }
        }
    }

    createHiddenInputs() {
        const form = document.querySelectorAll('[is="product-form"]');

        for (let index = 0; index < form.length; index++) {
            const hidden1 = document.createElement('input');
            hidden1.type = 'hidden';
            hidden1.name = 'properties[text]';
            hidden1.value = '';
            const hidden2 = document.createElement('input');
            hidden2.type = 'hidden';
            hidden2.name = 'properties[flag]';
            hidden2.value = '';

            form[index].appendChild(hidden1);
            form[index].appendChild(hidden2);
        }
    }

    saveOptions() {
        let pass = true;

        if (this.textInput.value.length === 0) {
            this.textInput.classList.add('error');
            pass = false;
        }

        if (this.flagSelect.value.length === 0) {
            this.flagSelect.classList.add('error');
            pass = false;
        }

        if (pass) {
            const image = this.selectedFlagContainer.querySelector('img').cloneNode();
            this.clearCustomizerResultContainer();
            this.customizerResultContainer.insertAdjacentHTML('beforeend', `<span></span> <span>${this.textInput.value}</span>`);
            this.customizerResultContainer.firstElementChild.nextElementSibling.appendChild(image);
            this.customizerButton.textContent = this.getAttribute('data-edit-label');
            this.customizerResultContainer.classList.remove('hidden');
            this.setHiddenInputValue(this.textInput.value, this.flagSelect.options[this.flagSelect.selectedIndex].text);
            this.hide();
        }
    }

    clearCustomizerResultContainer() {
        const children = this.customizerResultContainer.children;

        for (let index = children.length; index--;) {
            if (children[index].tagName === 'SPAN') {
                children[index].remove();
            }
        }
    }

    cancelData() {
        this.textInput.value = '';
        this.flagSelect.value = '';
        this.selectedFlagContainer.innerHTML = '';
        this.entredTextContainer.innerHTML = '';
        this.remainingCharsContainer.textContent = `(20 ${this.remainingCharsContainer.getAttribute('data-label')})`;
        this.setHiddenInputValue('', '');
        this.clearCustomizerResultContainer();
        this.customizerResultContainer.classList.add('hidden');
        this.customizerButton.textContent = this.getAttribute('data-save-label');
    }

    get initialFocus() {
        return false;
    }
};
if (!window.customElements.get("product-customizer")) {
    window.customElements.define("product-customizer", ProductCustomizer);
}



export {
    MobileNavigationDrawer,
    CustomSectionHeader,
    CustomDrawer,
    CustomFacetDrawer,
    CustomFacetApplyButton,
    DrawerFacetLink,
    ProductCustomizer
}